export class JwtHelper {
  public static getTokenPayload(token: string | null): { exp?: number } {
    try {
      if (token) {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        const jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
            .join("")
        );
        return JSON.parse(jsonPayload);
      } else {
        return {};
      }
    } catch (exception) {
      return {};
    }
  }

  public static isTokenValid(
    token: string | null,
    serverDateDifference = 0
  ): boolean {
    const tokenPayload: { exp?: number | undefined } =
      this.getTokenPayload(token);
    if (
      tokenPayload &&
      Object.prototype.hasOwnProperty.call(tokenPayload, "exp")
    ) {
      return Date.now() < (tokenPayload.exp ?? 0) * 1000 + serverDateDifference; // eslint-disable-line
    } else {
      return false;
    }
  }

  public static getTokenExpiryTimestamp(
    token: string | null,
    serverDateDifference = 0
  ): number {
    const tokenPayload = this.getTokenPayload(token);
    if (
      tokenPayload &&
      Object.prototype.hasOwnProperty.call(tokenPayload, "exp")
    ) {
      return (tokenPayload.exp ?? 0) * 1000 + serverDateDifference;
    } else {
      return 0;
    }
  }
}
